var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-ctrl-viewer" },
    [
      _vm.isMultiple
        ? _c(
            "w-playlist-small",
            _vm._b(
              {},
              "w-playlist-small",
              { playlist: _vm.playlist, index: _vm.index, size: _vm.size },
              false
            )
          )
        : _vm._e(),
      _vm.isMedia
        ? _c("w-seek-minimal", {
            attrs: {
              length: _vm.contentLength,
              size: _vm.size,
              value: _vm.playTime,
            },
            on: { input: _vm.seek },
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "buttons" },
        [
          _vm.isMultiple
            ? _c("w-btn-back", {
                attrs: { size: _vm.size },
                on: { click: _vm.back },
              })
            : _vm._e(),
          _vm.isMedia
            ? _c(
                "w-btn-play-pause",
                _vm._b(
                  { on: { play: _vm.play, pause: _vm.pause } },
                  "w-btn-play-pause",
                  { size: _vm.size, paused: _vm.paused },
                  false
                )
              )
            : _vm._e(),
          _vm.isMultiple
            ? _c("w-btn-next", {
                attrs: { size: _vm.size },
                on: { click: _vm.next },
              })
            : _vm._e(),
          _vm.hasVolume
            ? _c(
                "w-btn-volume",
                _vm._b(
                  {
                    attrs: { value: _vm.volume },
                    on: {
                      mute: _vm.mute,
                      unmute: _vm.unmute,
                      input: _vm.setVolume,
                    },
                  },
                  "w-btn-volume",
                  { size: _vm.size, muted: _vm.muted },
                  false
                )
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }